function CancelSuspend() {
  this.init = function() {
    if (!session.pension.secondPillar.isSuspended) {
      location.href = '/'
    }

    new UpdateContactInfo(session.customer, onCustomerDataUpdated).init()

    return {
      customer: session.customer
    }
  }

  function onCustomerDataUpdated() {
    location.reload()
  }

  this.done = function () {
    $('#sign-cancel-suspend').on('click', sign)
  }

  function prepare() {
    $('#sign-cancel-suspend').attr('disabled', true)
    return $.post('/application/second-pillar/suspend/cancel', {})
  }

  function sendApplication(signedDocument) {
    let post = $.post('/application/second-pillar/suspend/cancel/send-application', signedDocument)
    return post.fail(function (xhr) {
      Logger.error('Application  : ' + xhr.responseText);
      if (xhr.responseJSON) {
        $('#submission-error').text(xhr.responseJSON.error).removeClass('d-none')
      }
    })
  }

  function onSigned(signedDocument) {
    sendApplication(signedDocument).then(function() {
      location.href = '#success?cancellation=true' +
        '&signedDocumentId=' + signedDocument['signedDocumentId'] +
        '&applicationId=' + signedDocument['applicationId'];
    })
  }

  function sign() {
    $('#technical-error').addClass('d-none')
    new Signer(session.authType, prepare, onSigned).sign()
    return false;
  }
}
